/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useCallback } from "react";
//import { useSelector } from "react-redux";
import { FormOutlined, CheckCircleOutlined } from "@ant-design/icons";

import {
  GetListRoleModulePermissionsByCompanyService,
  SaveRolePermissionsService,
  GetListPermissionsRoleModulePermissionsByCompanyService,
} from "services/roles/services";
import {
  getListUserModulePermissionsByCompanyService,
  getListPermissionsUserModulePermissionsByCompanyService,
  saveUserPermissionsService,
  changePermissionsUserModeService,
} from "services/permissionUser/permissionUserService";

import SubmitButtonNoSubmit from "components/submitButton/SubmitButtonNoSubmit";
import CloseButton from "components/closeButton/CloseButton";
import Switch from "components/switchButton/Switch";
import { useNotifications } from "context/Notifications";
import { useTranslator } from "context/translator";
import Loading from "components/loading/Loading";
import PermissionsPanel from "components/permissions/permissionPanel/PermissionsPanel";
import { useModalMessageConfirmation } from "context/ModalMessageConfirmation";

export default function PermissionsConfigurationModal({
  openP,
  companyId,
  roleId,
  selectedType,
  selectedItem,
  disabledPermissions,
  onClose,
}) {
  //const { user } = useSelector((state) => state.user);
  //const { company } = useSelector((state) => state.company);

  const { AddNoti } = useNotifications();
  const { translate } = useTranslator();
  const [isLoading, setIsLoading] = useState(false);

  const [modalModuleOpen, SetModalModuleOpen] = useState(false);
  const [modalPermissionsOpen, SetModalPermissionsOpen] = useState(false);

  const [modulesPermissions, SetModulesPermissions] = useState([]);
  const [subModulePermissions, SetSubModulePermissions] = useState([]);
  const [initModuleCompleted, setInitModuleCompleted] = useState(false);
  const [initPermissionsCompleted, setInitPermissionsCompleted] =
    useState(false);
  const [selectedModule, setSelectedModule] = useState({});
  const [pendingChanges, SetPendingChanges] = useState(false);
  const [possiblePendingChanges, SetPossiblePendingChanges] = useState(false);
  const [modalModulesTitle, SetModalModulesTitle] = useState("");
  const [modalSubModulesTitle, SetModalSubModulesTitle] = useState("");

  const { ShowConfirm, ShowMessage } = useModalMessageConfirmation(); // ShowMessage(message, title)  const response = Await ShowConfirm(message, title, btnAcceptText, focus (true=Accept | false=Cancel | null=None), btnCancelText)

  const ModalPermissionsConfigurationCloseConfirm = useCallback(() => {
    ResetData();
    onClose();
  }, [onClose]);
  const ModalPermissionsConfigurationClose = useCallback(async () => {
    if (pendingChanges) {
      const resultado = await ShowConfirm(
        translate("pending-changes-confirm"),
        translate("pending-changes"),
        null,
        false, // focus: true Accept | false Cancel | null None
        null,
      );

      if (resultado) {
        ModalPermissionsConfigurationCloseConfirm();
      }
    } else {
      ModalPermissionsConfigurationCloseConfirm();
    }
  }, [
    pendingChanges,
    ShowConfirm,
    translate,
    ModalPermissionsConfigurationCloseConfirm,
  ]);

  const ModalModulePermissionsConfigurationClose = useCallback(() => {
    setSelectedModule({});
    SetSubModulePermissions([]);
    SetModalPermissionsOpen(false);
  }, [subModulePermissions]);

  const GetListModulePermissionsConfigurationByCompany =
    useCallback(async () => {
      setIsLoading(true);

      let params = {
        companyId: companyId,
        roleId: roleId,
      };

      let callback = null;

      if (selectedType === "ROLE") {
        callback = await GetListRoleModulePermissionsByCompanyService(params);
      } else if (selectedType === "USER") {
        params.userId = selectedItem._id;

        callback = await getListUserModulePermissionsByCompanyService(params);
      }

      if (callback.ok) {
        SetModulesPermissions(callback.obj);

        setInitModuleCompleted(true);
      } else {
        AddNoti(
          callback.msg != null ? translate(callback.msg) : "",
          translate("error-request-api"),
          2,
        );

        ModalPermissionsConfigurationClose();
      }

      setIsLoading(false);
    }, [AddNoti, translate, companyId, roleId, selectedType, selectedItem]);

  const SwitchChangeModuleAllow = async (
    modItem,
    allow,
    showValidationOnDisabled,
  ) => {
    let continueAllow = false;

    if (allow) {
      let replyPermissions = false;

      replyPermissions =
        await GetListPermissionsModulePermissionsConfigurationByCompany(
          modItem,
          false,
          false,
        );

      if (replyPermissions) {
        continueAllow = true;
      }
    } else {
      if (showValidationOnDisabled) {
        const resultado = await ShowConfirm(
          translate("selected-permissions-lose-on-disable-sub-module"),
          modItem.module.name,
          null,
          false, // focus: true Accept | false Cancel | null None
          null,
        );

        if (resultado) {
          continueAllow = true;
          SetPermissionsModulesPermissions(modItem, null);
        }
      } else {
        continueAllow = true;
      }
    }

    if (continueAllow) {
      //let modd = null;

      await SetModulesPermissions((prev) =>
        prev.map((modRecord) => {
          if (modRecord._id !== modItem._id) return modRecord;
          // si continúa, es el registro que necesito manipular, sino todo good, sale de una

          const mod = { ...modRecord };

          mod.allow = allow;

          //modd = { ...mod };

          //if (noDebeCambiarNada) return modRecord;
          return mod;
        }),
      );

      // Quitó todo lo que tuviera actualmente, de una tira cambio pendiente
      if (!allow) {
        SetPendingChanges(true);
      }
    }
  };

  const SetPermissionsModulesPermissions = async (
    modItem,
    subModulePermissions,
  ) => {
    //alert("mostrar alarta en caso de true");

    await SetModulesPermissions((prev) =>
      prev.map((modRecord) => {
        if (modRecord._id !== modItem._id) return modRecord;
        // si continúa, es el registro que necesito manipular, sino todo good, sale de una

        const mod = { ...modRecord };

        mod.subModulePermissions = subModulePermissions;

        //if (noDebeCambiarNada) return modRecord;
        return mod;
      }),
    );
  };

  useEffect(() => {
    SetModalModuleOpen(openP);

    if (!openP) {
      ResetData();
      return;
    }

    // si abre
    setInitModuleCompleted(false);
    ResetData();
    GetListModulePermissionsConfigurationByCompany();

    if (selectedType === "ROLE") {
      SetModalModulesTitle(
        `${translate("permissions")} - ${selectedItem?.name}`,
      );
    } else if (selectedType === "USER") {
      //console.log("selectedItem", selectedItem);

      SetModalModulesTitle(
        `${translate("permissions")} - ${selectedItem?.firstName}`,
      );
    }

    // OJO: aquí pones dependencias estables
  }, [openP, selectedType]); // , onClose, selectedItem?._id, selectedItem?.companyId, AddNoti, translate

  useEffect(() => {
    if (initModuleCompleted === true) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [initModuleCompleted]);

  const ResetData = () => {
    // Resetear en predeterminado las demás variables para que al utilizar la funcionalidad, todo esté de 0
    // Setea únicamente todo lo de acá, no lo que recibe como parámetro
    SetModulesPermissions([]);
    SetPendingChanges(false);
    SetPossiblePendingChanges(false);
    SetModalModulesTitle("");
    //SetSubModulePermissions([]);
    //setSelectedModule({});
    //SetPendingChanges(false);
    //SetPossiblePendingChanges(false);
    //setInitModuleCompleted(false);
  };

  const ChangePermissionsUserMode = useCallback(
    async (newDefaultPermissions) => {
      let userModeWord = "";

      if (newDefaultPermissions) {
        userModeWord = "default";
      } else {
        userModeWord = "custom";
      }

      const resultado = await ShowConfirm(
        translate(`change-to-${userModeWord}-confirmation`),
        translate(`change-to-${userModeWord}`),
        null,
        false, // focus: true Accept | false Cancel | null None
        null,
      );

      if (resultado) {
        setIsLoading(true);

        let params = {
          companyId: companyId,
          userId: selectedItem._id,
          roleId: roleId,
          defaultPermissions: newDefaultPermissions,
        };

        //console.log("params", params);

        changePermissionsUserModeService(params).then((callback) => {
          if (callback.ok) {
            AddNoti(translate(callback.msg), null, 1);

            ModalModulePermissionsConfigurationClose();

            ResetData();
            onClose(70);
          } else {
            AddNoti(
              callback.msg != null ? translate(callback.msg) : "",
              translate("error-request-api"),
              2,
            );
            setIsLoading(false);
          }

          //
        });
      }
    },
    [companyId, roleId, selectedItem],
  );

  const ViewModulePermissions = function (mod) {
    //console.log("asd");

    setInitPermissionsCompleted(false);

    SetModalPermissionsOpen(true);

    setSelectedModule({ ...mod });

    GetListPermissionsModulePermissionsConfigurationByCompany(mod, true, true);
  };

  const GetListPermissionsModulePermissionsConfigurationByCompany = useCallback(
    async (mod, openModal, dbPermissionsAllow) => {
      let reply = false;

      if (
        mod.subModulePermissions !== undefined &&
        mod.subModulePermissions !== null
      ) {
        SetSubModulePermissions(mod.subModulePermissions);

        setInitPermissionsCompleted(true);

        reply = true;
      } else {
        let callback = null;

        setIsLoading(true);

        let params = {
          companyId: companyId,
          moduleId: mod.module._id,
          dbPermissionsAllow: dbPermissionsAllow, // TRUE: usa los de la base   | FALSE: marca todo en true, ya que está habilitando apenas
          roleId: roleId,
        };

        if (selectedType === "ROLE") {
          //params.roleId = selectedItem._id;

          callback =
            await GetListPermissionsRoleModulePermissionsByCompanyService(
              params,
            );
        } else if (selectedType === "USER") {
          params.userId = selectedItem._id;
          params.defaultPermissions = selectedItem.defaultPermissions;

          callback =
            await getListPermissionsUserModulePermissionsByCompanyService(
              params,
            );
        }

        if (callback.ok) {
          //console.log("mod.subModulePermissions", mod.subModulePermissions);
          //console.log("callback.obj", callback.obj);

          if (
            (mod.subModulePermissions === undefined ||
              mod.subModulePermissions === null) &&
            callback.obj.length === 0
          ) {
            AddNoti(translate("no-module-permissions-available"), null, 3);
          } else {
            // variable del listado principal, para que tenga los permisos actualizados
            await SetPermissionsModulesPermissions(mod, callback.obj);

            if (openModal) {
              // Acá es solo cuando se necesite modificar los permisos de algún módulo
              SetSubModulePermissions(callback.obj);
            }

            setInitPermissionsCompleted(true);

            if (!dbPermissionsAllow) {
              SetPendingChanges(true);
            }

            reply = true;

            if (selectedType === "ROLE") {
              SetModalSubModulesTitle(
                `${translate("permissions")} - ${selectedItem?.name} - ${translate(mod?.module?.name)}`,
              );
            } else if (selectedType === "USER") {
              SetModalSubModulesTitle(
                `${translate("permissions")} - ${selectedItem?.firstName} - ${translate(mod?.module?.name)}`,
              );
            }
          }
        } else {
          AddNoti(
            callback.msg != null ? translate(callback.msg) : "",
            translate("error-request-api"),
            2,
          );

          ModalModulePermissionsConfigurationClose();

          // defaultPermissions no coincide lo de la base con lo del front-end, entonces amerita refrescar la info, ya que dependiendo el true/false del valor en base, retorna permisos predeterminados o permisos personalizados, entonces puede que no coincida la jugada
          if (selectedType === "USER" && callback.code === 70) {
            ShowMessage(callback.msg != null ? translate(callback.msg) : "");

            ResetData();
            onClose(70);
          }
        }

        setIsLoading(false);
      }

      return reply;
    },
    [
      AddNoti,
      translate,
      ModalModulePermissionsConfigurationClose,
      roleId,
      selectedItem,
    ],
  );

  const ModuleSubModulesPermissionsAtLeastOneAllow = function (
    subModulePermissions,
  ) {
    let reply = false;

    if (subModulePermissions !== undefined && subModulePermissions !== null) {
      subModulePermissions.forEach((value) => {
        if (value.allow) {
          reply = true;
        }
      });
    }

    return reply;
  };

  const SaveModulePermissionsConfiguration = function () {
    if (possiblePendingChanges) {
      SetPendingChanges(true);
    }

    SetPermissionsModulesPermissions(selectedModule, subModulePermissions);

    let subSoduleAllowAtLeast =
      ModuleSubModulesPermissionsAtLeastOneAllow(subModulePermissions);

    // No tiene ningún permiso habilitado, ya que no tiene ningún sub-módulo habilitado, entonces se quita el módulo
    if (!subSoduleAllowAtLeast) {
      SwitchChangeModuleAllow(selectedModule, false, false);
      SetPermissionsModulesPermissions(selectedModule, null);
    }

    ModalModulePermissionsConfigurationClose();
  };

  const SavePermissionsConfiguration = async function () {
    setIsLoading(true);

    let newModulesPermissions = [];

    modulesPermissions.forEach((value) => {
      newModulesPermissions.push({
        ...value,
        module: null,
        subModulePermissions: value.allow ? value.subModulePermissions : null,
      });
    });

    let params = {
      companyId: companyId,
      modulesPermissions: newModulesPermissions,
      roleId: roleId,
    };

    let callback = null;

    if (selectedType === "ROLE") {
      callback = await SaveRolePermissionsService(params);
    } else if (selectedType === "USER") {
      params.userId = selectedItem._id;

      callback = await saveUserPermissionsService(params);
    }

    if (callback.ok) {
      AddNoti(translate(callback.msg), null, 1);

      SetPendingChanges(false);
      SetPossiblePendingChanges(false);

      //SetModulesPermissions(callback.obj);

      //setInitModuleCompleted(true);
    } else {
      AddNoti(
        callback.msg != null ? translate(callback.msg) : "",
        translate("error-request-api"),
        2,
      );
    }

    //ModalPermissionUserClose(); // no cerrar nada

    setIsLoading(false);
  };

  return (
    <>
      {modalModuleOpen && (
        <div
          id="modalID"
          tabIndex="-1"
          aria-hidden="true"
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50 overflow-y-auto"
        >
          <div className="relative p-4 w-full max-w-2xl max-h-full">
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {modalModulesTitle}
                </h3>
                <button
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="modalID"
                  onClick={ModalPermissionsConfigurationClose}
                  disabled={isLoading}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only"> Close modal </span>
                </button>
              </div>
              <div className="p-4 md:p-5">
                {isLoading && !initModuleCompleted ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                    {translate("loading-data")}
                  </div>
                ) : (
                  //) : employeeData.length === 0 ? (
                  //    <NoResults message="No members found" />
                  <div>
                    <div className="grid gap-6 md:grid-cols-2">
                      {modulesPermissions.map((mod) => (
                        <div key={mod._id}>
                          <div>
                            <div className="switch-middle-align">
                              <div className="grid gap-3 mb-6 grid-cols-3">
                                <div className="dark:text-white col-span-2">
                                  <label> {translate(mod.module.name)} </label>

                                  {mod.allow && (
                                    <span>
                                      &nbsp;
                                      <button
                                        type="button"
                                        onClick={() =>
                                          ViewModulePermissions(mod)
                                        }
                                        title={translate("permissions")}
                                        disabled={isLoading}
                                      >
                                        <FormOutlined
                                          className="w-6 h-6 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                                          style={{ fontSize: "19px" }}
                                        />
                                      </button>
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <Switch
                                    value={mod.allow}
                                    onChange={(newValue) =>
                                      SwitchChangeModuleAllow(
                                        mod,
                                        newValue,
                                        true,
                                      )
                                    }
                                    disabled={disabledPermissions}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <br />

                    <div className="grid gap-6 mb-1 grid-cols-2">
                      <div style={{ color: "indianred" }}>
                        {pendingChanges && (
                          <div>*{translate("pendingChanges")}</div>
                        )}
                      </div>
                      <div>
                        <div className="flex justify-end items-center gap-4">
                          {selectedType === "USER" && !isLoading && (
                            <>
                              {selectedItem?.defaultPermissions ? (
                                <button
                                  onClick={() =>
                                    ChangePermissionsUserMode(false)
                                  }
                                  className="text-white 
                                                                            hover:bg-gradient-to-r from-green-400 via-green-500 to-green-600
                                                                            focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg 
                                                                            text-sm px-5 py-2.5"
                                  title={translate("change-to-custom")}
                                  disabled={isLoading}
                                >
                                  <CheckCircleOutlined
                                    className="w-6 h-6 text-green-400 group-hover:text-green-500 dark:text-green-500 dark:group-hover:text-green-300"
                                    style={{ fontSize: "19px" }}
                                  />
                                  &nbsp;
                                  {translate("default")}
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    ChangePermissionsUserMode(true)
                                  }
                                  className="text-white 
                                                                        hover:bg-gradient-to-r from-green-400 via-green-500 to-green-600
                                                                        focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg 
                                                                        text-sm px-5 py-2.5"
                                  title={translate("change-to-default")}
                                  disabled={isLoading}
                                >
                                  <CheckCircleOutlined
                                    className="w-6 h-6 text-green-400 group-hover:text-green-500 dark:text-green-500 dark:group-hover:text-green-300"
                                    style={{ fontSize: "19px" }}
                                  />
                                  &nbsp;
                                  {translate("custom")}
                                </button>
                              )}
                            </>
                          )}

                          {disabledPermissions ? (
                            <>
                              <CloseButton
                                isLoading={isLoading}
                                textLoading={translate("saving")}
                                onClick={ModalPermissionsConfigurationClose}
                              />
                            </>
                          ) : (
                            <>
                              <SubmitButtonNoSubmit
                                isLoading={isLoading}
                                textLoading={translate("saving")}
                                text={translate("save")}
                                onClick={SavePermissionsConfiguration}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Este modal solo va a tener los permisos del MOMENTO, pero tienen que retornarse al objeto (módulo) que le corresponde  */}
      {modalPermissionsOpen && (
        <div
          id="modalID"
          tabIndex="-1"
          aria-hidden="true"
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-50 overflow-y-auto"
        >
          <div className="relative p-4 w-full max-w-2xl max-h-full">
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                  {modalSubModulesTitle}
                </h3>
                <button
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="modalID"
                  onClick={() => ModalModulePermissionsConfigurationClose()}
                  disabled={isLoading}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only"> Close modal </span>
                </button>
              </div>
              <div className="p-4 md:p-5">
                {isLoading && !initPermissionsCompleted ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                    {translate("loading-data")}
                  </div>
                ) : (
                  //) : employeeData.length === 0 ? (
                  //    <NoResults message="No members found" />
                  <div>
                    <div className="grid gap-6 md:grid-cols-1">
                      <PermissionsPanel
                        openP={modalPermissionsOpen}
                        subModulos={subModulePermissions}
                        setSubModulos={SetSubModulePermissions}
                        disabledPermissions={disabledPermissions}
                        onDirty={() => SetPossiblePendingChanges(true)}
                      />
                    </div>

                    <br />

                    <div className="grid gap-6 mb-1 grid-cols-1">
                      <div>
                        {disabledPermissions ? (
                          <div style={{ textAlign: "right" }}>
                            <button
                              onClick={ModalModulePermissionsConfigurationClose}
                              className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
                            >
                              {translate("close")}
                            </button>
                          </div>
                        ) : (
                          <div>
                            <SubmitButtonNoSubmit
                              isLoading={isLoading}
                              textLoading={translate("saving")}
                              text={translate("save")}
                              onClick={SaveModulePermissionsConfiguration}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
